import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { PublicNoticePDF } from './Pdffiles'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
// import { Layout } from '@/components/layouts/Ir'
import { BulletedList } from '@/components/layouts/PublicNotice/BulletedList'
// import { Paragraph } from '@/components/layouts/Ir/Paragraph'

import { BulletinDigest, Company, PublicNotice } from '@/types/publicNotice'

type Props = {
  bulletinDigest: BulletinDigest
  companyList: Array<Company>
  bulletinList: { [key: string]: PublicNotice[] }
  finalAccountList: { [key: string]: PublicNotice[] }
}

export const PublicNoticePage = ({
  bulletinDigest,
  companyList,
  bulletinList,
  finalAccountList,
}: Props) => {
  return (
    <Container>
      <SectionTitle
        titleText="Electronic Public Notice"
        subTitleText="電子公告"
        color="normal"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      {bulletinDigest.title && (
        <section>
          <Paragraph>{bulletinDigest.summary}</Paragraph>
          <Spacer h={{ sp: 10, pc: 15 }} />
          {bulletinDigest.listItems.length > 0 && (
            <BulletedList>
              {bulletinDigest.listItems
                .slice(1)
                .split('→')
                .map((value, index) => (
                  <li key={`${index}${value}`}>{value}</li>
                ))}
            </BulletedList>
          )}
          <Spacer h={{ sp: 70, pc: 100 }} />
        </section>
      )}
      {companyList.map((company) => (
        <Fragment key={`${company._id}`}>
          <PublicNoticePDF
            company={company}
            bulletin={bulletinList[company._id]}
            finalAccount={finalAccountList[company._id]}
          />
          <Spacer h={{ sp: 70, pc: 100 }} />
        </Fragment>
      ))}
    </Container>
  )
}

PublicNoticePage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '電子公告', path: '' },
  ]

  return (
    <>
      <Head
        title="電子公告"
        description="トライアルホールディングスグループの公告について掲載しています。"
        ogp={{ url: '/public-notice' }}
      />
      <TitleLayout
        title="Electronic Public Notice"
        subTitle="電子公告"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

export const Paragraph = styled.p`
  font-size: 16px;
  line-height: 190%;

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    line-height: 180%;
  }
`

export const Container = styled.div`
  width: 1040px;
  margin: 94px auto 130px;

  @media screen and (max-width: 1047px) {
    margin: 38px auto 120px;
    width: 100%;
    padding: 0 20px;
  }
`
